<template>
  <div class="card-container">
    <a-row>
      <a-col :span="12">
        <a-menu v-model="current"
                :default-selected-keys="['hotel']"
                mode="horizontal">
          <a-menu-item key="ticket">
            <a :href="'/train-admin/channelShop/policy-ticket?distributorId='+globalDistributorId" rel="noopener noreferrer">飞机票</a>
          </a-menu-item>
          <a-menu-item key="train">
            <a :href="'/train-admin/channelShop/policy-train?distributorId='+globalDistributorId" rel="noopener noreferrer">火车票</a>
          </a-menu-item>
          <a-menu-item key="hotel">
            <a :href="'/train-admin/channelShop/policy-hotel?distributorId='+globalDistributorId"  rel="noopener noreferrer">酒店</a>
          </a-menu-item>
        </a-menu>
      </a-col>
      <a-col :span="12">
        <span style="float: right;margin-top:8px;">
          <a-button type="primary" @click="showLevelModal">选择职级</a-button>
        </span>
      </a-col>
    </a-row>

  </div>
  <a-tabs :animated="false" default-active-key="1" @change="callback">
    <a-tab-pane key="1" tab="基础配置">
      <a-form :model="policyForm" :label-col="labelCol" :wrapper-col="wrapperCol">
        <a-form-item label="超标管控:">
          <a-radio-group v-model:value="policyForm.control">
            <a-radio value="deny">
              允许
            </a-radio>
            <a-radio value="allow">
              不允许
            </a-radio>
            <a-radio value="warn">
              仅提醒
            </a-radio>
          </a-radio-group>
        </a-form-item>
        <a-form-item label="超标处理:">
          <a-radio-group v-model:value="policyForm.disposal">
            <a-radio value="approval">
              审批
            </a-radio>
            <a-radio value="payment">
              自付
            </a-radio>
          </a-radio-group>
        </a-form-item>
        <a-form-item label="超标原因:">
          <a-radio-group v-model:value="policyForm.reasonRequired">
            <a-radio value="Y">
              必填
            </a-radio>
            <a-radio value="N">
              非必填
            </a-radio>
          </a-radio-group>
        </a-form-item>
        <a-form-item label="公告内容" name="notice">
          <a-textarea v-model:value="policyForm.notice" />
        </a-form-item>
        <a-form-item :wrapper-col="{ span: 14, offset: 4 }">
          <a-button type="primary" @click="onSubmit">
            保存修改
          </a-button>
        </a-form-item>
      </a-form>
    </a-tab-pane>
    <a-tab-pane key="2" tab="标准配置">

      <a-table :pagination='false' :row-key="r => r.id" :columns="hotelBaseColumns" :data-source="hotelBaseData">
        <template v-slot:rank="{ text,record,index }">
          <a>{{ record.levelName }}</a>
        </template>
        <template v-slot:cityList="{ text,record,index }">
          <a-tag v-for="(item,index) in record.cityList">{{item}}</a-tag>
        </template>
        <template v-slot:config="{ text,record,index }">
          <span>
            <a-button @click="toHotelControl(record)" type="primary" size="small">
              配置差标
            </a-button>
          </span>
        </template>
        <template v-slot:operate="{ text,record,index }">
          <a-button @click="deleteHotelLevel(record)" type="danger" size="small">
            删除
          </a-button>
        </template>
      </a-table>
    </a-tab-pane>
  </a-tabs>

  <a-modal v-model:visible="levelModalVisible" title="选择职级" @ok="selectLevel">
    <a-radio-group v-model:value="distributorLevelValue" @change="onChange">
      <a-radio :value="item.levelNo" v-for="(item,index) in distributorLevelList" :key="index">
        {{ item.levelName }}
      </a-radio>
    </a-radio-group>
  </a-modal>

</template>

<script>
import {SmileOutlined, DownOutlined} from '@ant-design/icons-vue';
import {useRoute, useRouter} from "vue-router";
import policy from '@axios/policy'
import {ref} from "vue";
import { notification } from 'ant-design-vue';

export default {
  components: {
    SmileOutlined,
    DownOutlined,
  },
  name: "index",
  setup() {
    const router = useRouter()
    const route = useRoute()
    const business = 20
    const globalDistributorId = route.query.distributorId

    let policyForm = ref({
      id: null,
      control: null,
      disposal: null,
      reasonRequired: null,
      distributorId: globalDistributorId,
      business: business,
      notice: null
    })

    const policyList = [{}]
    const labelCol = {span: 4}
    const current = ['hotel']
    const form = {
      name: '',
    }

    const toHotelControl = (row) => {
      console.log(row)
      console.log("--------")
      router.push({
        name: 'policyHotelControlIndex',
        query: {
          levelName:row.levelName,
          policyHotelBaseId: row.id,
          distributorId: row.distributorId,
          policyBaseId: row.policyBaseId
        }
      });
    }

    const findPolicy = () => {
      const _policyForm = {
        control: policyForm.value.control,
        disposal: policyForm.value.disposal,
        reasonRequired: policyForm.value.reasonRequired,
        distributorId: policyForm.value.distributorId,
        business: policyForm.value.business,
      }
      console.log(_policyForm)
      policy.getPolicy(_policyForm).then(p => {
        policyForm.value = {
          distributorId: p.distributorId,
          control: p.control,
          disposal: p.disposal,
          reasonRequired: p.reasonRequired,
          business: business,
          id: p.id,
          notice: p.notice
        }
        console.log(policyForm)
        getPolicyLevelList()
      })
    }
    findPolicy()


    const onChange = (e) => {
      console.log('radio checked', e.target.value);
    }

    //职级对话框
    let distributorLevelValue = ref(null)
    let distributorLevelList = ref([])
    let levelModalVisible = ref(false)
    const showLevelModal = () => {
      levelModalVisible.value = true;
      let query = {
        distributorId: policyForm.value.distributorId
      }
      policy.getLevelList(query).then(l => {
        distributorLevelList.value = l
      })
    }

    const selectLevel = (e) => {
      console.log(e)
      levelModalVisible.value = false
      if (!distributorLevelValue._value) {
        openNotificationWithIcon('warning','请选择直职级！！！')
        return
      }
      const policyLevel = {
        levelId: distributorLevelValue._value,
        policyBaseId: policyForm.value.id,
        business: business,
        distributorId: policyForm.value.distributorId
      }
      console.log(policyLevel)
      policy.addPolicyLevel(policyLevel).then(a => {
        console.log(a)
      })
    }

    const popupScroll = () => {
      console.log('popupScroll');
    }

    const callback = (key) => {
      getPolicyLevelList()
      console.log("callback", key);
    }

    const onSubmit = () => {
      console.log('submit!', policyForm);
      const _policyForm = policyForm.value
      policy.addAndEditPolicy(_policyForm).then(p => {
        console.log(p)
        openNotificationWithIcon('success','修改成功.')
      })
    }


    let hotelBaseData = ref([])
    const hotelBaseColumns = ref([
          {
            dataIndex: 'levelName',
            title: '职级',
            key: 'levelName',
            width: "10%",
            align: 'center',
            slots: {customRender: 'levelName'},
          },
          {
            title: '城市',
            dataIndex: 'cityList',
            align: 'left',
            key: 'cityList',
            width: "70%",
            slots: {customRender: 'cityList'},
          },
          {
            title: '配置',
            dataIndex: 'config',
            align: 'left',
            key: 'config',
            width: "10%",
            slots: {customRender: 'config'},
          },
          {
            title: '操作',
            key: 'operate',
            width: "10%",
            align: 'center',
            dataIndex: 'operate',
            slots: {customRender: 'operate'},
          }
        ]
    )
    const wrapperCol = {span: 14}

    //获取职级相关信息
    const getPolicyLevelList = () => {
      const query = {
        policyBaseId: policyForm.value.id
      }
      console.log(query)
      policy.getPolicyLevel(query).then(l => {
        console.log(l)
        hotelBaseData.value = l
      })
    }

    //删除职级
    const deleteHotelLevel = () => {

    }

    const openNotificationWithIcon = (type,description) => {
      notification[type]({
        message: '提示信息',
        description:description,
      });
    }

    return {
      globalDistributorId,
      business,
      toHotelControl,
      findPolicy,
      onChange,
      showLevelModal,
      selectLevel,
      popupScroll,
      callback,
      onSubmit,
      policyForm,
      hotelBaseData,
      hotelBaseColumns,
      levelModalVisible,
      deleteHotelLevel,
      distributorLevelValue,
      distributorLevelList,

      policyList,
      labelCol,
      wrapperCol,
      current,
      form
    }
  },
}
</script>

<style rel="stylesheet/scss" lang="scss">
.ant-tabs-nav-scroll {
  background-color: #F3F3F3;
}

.ant-col-4 {
  width: 100px;
}

.ant-col-offset-4 {
  margin-left: 100px;
}
</style>

<style rel="stylesheet/scss" lang="scss" scoped>

.ant-menu-item-active {
  background-color: #F3F3F3;
}

.card-container {
  overflow: hidden;
  padding: 0px;
}

.ant-menu-item-selected {
  background-color: #F3F3F3;
  border-bottom: none;
  width: 100px;
}

.ant-menu-item-selected a, .ant-menu-item > a {
  text-align: center;
  font-size: 16px;
}

.ant-menu-item:hover {
  border-bottom: none;
  background-color: #F3F3F3;
}

.ant-menu-item {
  width: 100px;
}

.ant-tabs-nav-wrap, .ant-tabs-nav-scroll {
  background-color: #F3F3F3;
  height: 80px;
}

.ant-tabs-tab-active {
  background-color: #F3F3F3;
}

.card-container > .ant-tabs-card > .ant-tabs-content {
  height: 120px;
  margin-top: -16px;
}

.card-container > .ant-tabs-card > .ant-tabs-content > .ant-tabs-tabpane {
  background: #fff;
  padding: 16px;
}

.card-container > .ant-tabs-card > .ant-tabs-bar {
  border-color: #fff;
}

.card-container > .ant-tabs-card > .ant-tabs-bar .ant-tabs-tab {
  border-color: transparent;
  background: transparent;
  margin: 0;
  text-align: center;
}

.card-container > .ant-tabs-card > .ant-tabs-bar .ant-tabs-tab-active {
  border-color: #fff;
  background: #fff;
}

.ant-select {
  padding-bottom: 5px;
}
</style>
